// @ts-nocheck
import {
  AloftDate,
  DatasetSource,
  MLSListing,
  ToolkitProperty,
  ToolkitPropertyRunner,
  formatToolkitRecordID,
  getToolkitListingID,
  identifyToolkitProperty,
  isUndefined,
  mlsInfoByConstellation1ID,
  toolkitPropertyRunnerFactory,
} from '@aloft/toolkit-shared';

export function listingsToToolkitProperties({
  listings,
  source,
}: {
  listings: MLSListing[];
  source: DatasetSource;
}): ToolkitProperty[] {
  const tkPropRunner: ToolkitPropertyRunner = toolkitPropertyRunnerFactory(source);

  const properties = [];

  for (const listing of listings) {
    try {
      if (source === 'constellation1') {
        const mlsInfo = mlsInfoByConstellation1ID(listing.OriginatingSystemName);
        if (isUndefined(mlsInfo)) continue;

        const property = tkPropRunner(AloftDate.today(), listing, mlsInfo.mlsid);
        if (property.listingStatus !== 'SettledSale') continue;

        const listingID = getToolkitListingID(property);
        if (listingID === undefined) continue;

        // TODO: Use order ID
        const id = formatToolkitRecordID({
          orderID: 'paired-sales',
          location: { t: 'dataset', datasetID: 'paired-sales', listingID },
        });

        properties.push(identifyToolkitProperty(property, id));
      } else if (source === 'abode') {
        const property = tkPropRunner(AloftDate.today(), listing, listing.MLSOUID);

        if (property.listingStatus !== 'SettledSale') continue;

        const listingID = getToolkitListingID(property, true);
        property.toolkitListingID = listingID;

        const id = formatToolkitRecordID({
          orderID: 'paired-sales',
          location: { t: 'dataset', datasetID: 'paired-sales', listingID },
        });

        properties.push(identifyToolkitProperty(property, id));
      }
    } catch (error) {
      console.error(error, { listing });
    }
  }

  return properties;
}
